module.exports = __webpack_public_path__ + "img/header.d89fd24b.jpg";